/**
 *
 * DEPRECATED - DO NOT USE IT IN NEW CODE
 * This file is only used by Recruiter Search a.k.a People Search page (/recruiter/search).
 * It also is compiled by deprecated Sprockets compiler.
 *
 * There is a newer version of the Bookmarked Searches logic built in AngularJS located at
 * `app/src/directives/bookmarked_searches` used in Funding Search. That logic can and
 * should be compiled in Vite.
 *
 *  How the controller is used in Recruiter Search a.k.a People Search page (/recruiter/search):
 *    <div ng-controller="deprecatedBookmarkedSearchController">
 *      <!-- directives go here -->
 *    </div>
 */

// = require devex/angular/searchJS
// = require devex/angular/filters/bookmarked_search_ownership
// = require devex/angular/filters/my_alert
// = require devex/angular/models/bookmarked-search
// = require devex/alerts

angular.module('bookmarkedSearches',[
  'filters.myBookmarkedSearches',
  'filters.sharedBookmarkedSearches',
  'filters.myAlert',
  'models.bookmarkedSearch',
  'devex.search'
])
  .controller('deprecatedBookmarkedSearchController', [
    '$scope',
    '$element',
    '$attrs',
    '$filter',
    '$timeout',
    'BookmarkedSearch',
    function(
      $scope,
      $element,
      $attrs,
      $filter,
      $timeout,
      BookmarkedSearch
    ) {

      $scope.delete = function(bookmarkedSearch) {
        bookmarkedSearch.deleting = true;
        bookmarkedSearch.$delete({id: bookmarkedSearch.id}, function() {
          var index = _.findIndex($scope.bookmarkedSearches, function(search) {
            return search.id === bookmarkedSearch.id;
          });
          if (index >= 0) {
            $scope.bookmarkedSearches.splice(index,1);
          }
        });
      };

      $scope.activate = function (bookmarkedSearch) {
        $element.trigger('activateBookmarkedSearch', bookmarkedSearch);
        $scope.search.loadParams(bookmarkedSearch.params);
        $scope.search.search();
        // ToDo: persist the last_accessed date
        // calling bookmarkedSearch.$save() creates a duplicate currently
        bookmarkedSearch.last_accessed = (new Date()).toISOString();
      };

      $scope.toggleAlert = function (bookmarkedSearch) {
        var myAlert = $filter('myAlert')(bookmarkedSearch.alerts);
        if (myAlert) {
          BookmarkedSearch.deleteAlert(
            { alert_id: myAlert.id },
            function () {
              $scope.reload();
              devex.alerts.showAlert(
                'You have successfully deactivated \'' + bookmarkedSearch.title + '\'.',
                'success'
              );
            }
          );
        } else {
          BookmarkedSearch.activateAlert(
            {
              alertable_type: 'BookmarkedSearch',
              alertable_id: bookmarkedSearch.id,
              interval: 7
            },
            function(alertResponse) {
              bookmarkedSearch.alerts[0] = angular.copy(alertResponse);
              // Success
              devex.alerts.showAlert(
                'You have successfully activated \'' + bookmarkedSearch.title + '\'.',
                'success'
              );
            }
          );
        }
      };

      $scope.reload = function() {
        BookmarkedSearch.query({
          search_type: 'consultants',
          'page[size]': 100
        }, function(result) {
          $scope.bookmarkedSearches = angular.copy(result);
        });
      };

      /**
       *  In People Search (/recruiter/search), we allow user to save a new saved search.
       *
       * @returns {undefined}
       */
      $scope.savePeopleSearchAlert = function () {
        var filterParams = $scope.search.getParams({
          includeQuery: true,
          includeFilter: true
        });

        if (Object.keys(filterParams).length === 0) {
          devex.alerts.showAlert(
            'Please select at least one filter before saving your search',
            'info'
          );
          return;
        }

        var params = {
          title: $scope.name,
          search_type: 'consultants',
          params: filterParams,
        };
        new BookmarkedSearch(params).$save(function() {
          $scope.reload();
          $element.trigger('newSearchSaved',
            {name: $scope.name, search_type: 'consultants'});
          $scope.name = '';
          devex.alerts.showAlert(
            'You have successfully created \'' + params.title + '\'',
            'success'
          );
        });
      };

      /**
       * Define event listener for the input focus in the Save search dropdown
       * the $timeout is needed to apply the focus in the element.
       *
       * @returns {undefined}
       */
      var defineEventListeners = function() {
        $('#showSaveSearch').on('click', function () {
          $timeout(function () {
            $('#saveSearch').focus();
          });
        });
      };

      $scope.init = function () {
        defineEventListeners();

        // Variable that is binded to the `Name your search input` in the Recruiter Search
        $scope.name = '';
        $scope.$on('alert-created', $scope.reload.bind($scope));
        $scope.reload();
      };

      $scope.init($attrs);
    }
  ]);

$('.stop-propagation').click(function(e) {
  e.stopPropagation();
});
